<template>
  <div class="promotion-position">
    <div class="pad-mar__title  ad-target">
      <h3 class="title">
        广告位目标
        <p class="sub-title">
          选择广告推广的目标，实现你的营销目标
        </p>
      </h3>
      <div class="block mar-bt__20">
        <el-Scrollbar style="width: 100%" :native="false">
          <div class="wrapper clearfix">
            <div
              class="components"
              :class="active === index ? 'active' : ''"
              v-for="(item, index) in filterCompSelect"
              :key="item.title"
              @click="changeActive(index)"
            >
              <div :is="item.component"></div>
              <h3 class="sub-title">
                {{ item.title }}
              </h3>
            </div>
          </div>
        </el-Scrollbar>
      </div>
    </div>
    <div class="editor clearfix">
      <el-Scrollbar style="width: 100%" :native="false">
        <div class="scroll-x">
          <div class="pad-mar__title ad-time">
            <h3 class="title">
              广告投放时间
              <p class="sub-title">
                选择投放时间，实现你的精准投放
              </p>
            </h3>
            <div class="form-wrapper">
              <el-form label-position="right" label-width="auto" :model="form">
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    投放方式：
                  </span>
                  <div class="radio-group">
                    <el-radio-group v-model="form.radio">
                      <el-radio :label="1">
                        cpm广告
                        <span class="tips">
                          每千次印象费用，广告条每显示1000次（印象）的费用
                        </span>
                      </el-radio>
                      <el-radio :label="2">
                        cpo广告(cost-per-order)
                        <span class="tips">
                          即根据每个订单/每次交易来收费的方式
                        </span>
                      </el-radio>
                      <el-radio :label="3">
                        cpa广告(cost-per-action)
                        <span class="tips">
                          每次行动的费用，即根据每个访问者对网络广告所采取的行动收费的定价模式。获得一个注册用户
                        </span>
                      </el-radio>
                      <el-radio :label="4">
                        cpc广告 (cost-per-click)
                        <span class="tips">
                          每次点击的费用。根据广告被点击的次数收费。如关键词广告一般采用这种定价模式
                        </span>
                      </el-radio>
                      <el-radio :label="5">
                        cpl广告(cost for per lead)
                        <span class="tips">
                          按付佣金
                        </span>
                      </el-radio>
                      <el-radio :label="6">
                        cpt广告(cost per Time)
                        <span class="tips">
                          按时间是计费
                        </span>
                      </el-radio>
                    </el-radio-group>
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    投放时间：
                  </span>
                  <div class="input-box datepick">
                    <div class="input">
                      <el-date-picker
                        v-model="form.time"
                        type="daterange"
                        unlink-panels
                        range-separator="至"
                        start-placeholder="开始日期"
                        end-placeholder="结束日期"
                        :picker-options="pickerOptions"
                      />
                    </div>
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    素材选择：
                  </span>
                  <div class="img">
                    <el-upload
                      class="ad-uploader"
                      action=""
                      :auto-upload="false"
                      :show-file-list="false"
                      :on-change="handleChange"
                    >
                      <img
                        v-if="form.imageUrl"
                        :src="form.imageUrl"
                        class="preview-img"
                      />
                      <div v-if="!form.imageUrl">
                        <i class="iconfont icon-tupian"> </i>
                        <p>上传图片</p>
                      </div>
                      <div class="opearting" v-if="form.imageUrl">
                        <span class="change">更换</span>
                        <i
                          @click.stop="delImg"
                          class="iconfont icon-shanchu"
                        ></i>
                      </div>
                    </el-upload>
                    <span class="tips">
                      (建议图片宽度640，高度384，支持类型JPG/PNG)
                    </span>
                  </div>
                  <div class="input-large">
                    <el-input placeholder="请输入SKU编码/链接" />
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    推广预算：
                  </span>
                  <div class="input-box " style="display: inline-block">
                    <span class="name">
                      每天预算：
                    </span>
                    <div class="input">
                      <el-select v-model="form.dailyBudget">
                        <el-option label="1" value="1" />
                      </el-select>
                    </div>
                  </div>
                  <div
                    class="input-box "
                    style="display: inline-block;margin-bottom: 3rem"
                  >
                    <span class="name">
                      本次预算：
                    </span>
                    <div class="input">
                      <el-select v-model="form.thisBudget">
                        <el-option label="1" value="1" />
                      </el-select>
                    </div>
                  </div>
                  <el-button round>锁定预算</el-button>
                  <div class="input-box">
                    <span class="name">账户余额：</span>
                    {{ form.accountBalance }}
                    <el-button
                      style="margin-left: 1.3rem"
                      class="export-color"
                      round
                      >去充值</el-button
                    >
                  </div>
                </el-form-item>
                <el-form-item>
                  <span slot="label">
                    <i class="red">*</i>
                    推广计划名称：
                  </span>
                  <div class="input-box">
                    <div class="input" style="width: 25rem;">
                      <el-input v-model="form.planName" placeholder="请输入" />
                    </div>
                  </div>
                </el-form-item>
              </el-form>
            </div>
            <div class="btn-all">
              <el-button size="98">保存</el-button>
              <el-button size="98" class="sub-color">提交审核</el-button>
            </div>
          </div>
          <div class="pad-mar__title preview-applets">
            <h3 class="title">
              效果预览
            </h3>
            <div class="decoration-wrap">
              <div class="modules">
                <div class="home-bg__frame">
                  <div class="block">
                    <el-Scrollbar style="height: 100%" :native="false">
                      <div
                        class="component"
                        v-for="item in compSelect"
                        :key="item.title"
                        :data-index="item.index"
                      >
                        <div class="drag">
                          <div :is="item.component"></div>
                        </div>
                      </div>
                    </el-Scrollbar>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </el-Scrollbar>
    </div>
  </div>
</template>
<script>
import pickerOptions from 'mixins/pickerOptions/'
import components from 'components/scanDecorationComponents'

export default {
  name: 'promotionPosition',
  mixins: [pickerOptions],
  data() {
    // 模块选择排序
    const componentClassify = [
      'Banner1',
      'BrandCode1',
      'Nav1',
      'Hot1',
      'BlockColor',
      'Group1',
      'New1',
      'Producing1',
      'Winery1',
      'Support1'
    ]
    this.compSelect = [
      {
        component: '',
        title: '01轮播banner图',
        index: 1
      },
      {
        component: '',
        index: 2
      },
      {
        component: '',
        index: 3
      },
      {
        component: '',
        title: '02人气推荐',
        index: 4
      },
      {
        component: '',
        index: -1
      },
      {
        component: '',
        title: '03拼团模块',
        index: 5
      },
      {
        component: '',
        index: 6
      },
      {
        component: '',
        index: 7
      },
      {
        component: '',
        title: '04酒庄推荐',
        index: 8
      },
      {
        component: '',
        index: 9
      }
    ]
    componentClassify.forEach((v, i) => {
      components.map(vm => {
        if (vm[v] !== undefined) {
          this.compSelect[i].component = vm[v]
        }
      })
    })
    return {
      active: '',
      form: {
        radio: 2,
        time: '',
        imageUrl: '',
        dailyBudget: '',
        thisBudget: '',
        accountBalance: '￥7000',
        planName: ''
      }
    }
  },
  computed: {
    /**
     * 过滤出需要的组件
     * @returns {*}
     */
    filterCompSelect() {
      return this.compSelect.filter(item => {
        return [1, 4, 5, 8].includes(item.index)
      })
    }
  },
  methods: {
    /**
     * 切换选中
     * @param index
     */
    changeActive(index) {
      this.active = index
    },
    /**
     * 文件上传改变
     * @param file
     */
    handleChange(file) {
      this.form.imageUrl = URL.createObjectURL(file.raw)
    },
    /**
     * 删除图片
     */
    delImg() {
      this.form.imageUrl = ''
    }
  }
}
</script>
<style lang="scss">
.promotion-position {
  overflow-x: hidden;
  .ad-target {
    min-height: 25rem;
    margin-bottom: 1.3rem;
  }

  .block {
    .wrapper {
      width: 125.1rem;
      overflow-y: hidden;
    }

    .components {
      width: 28rem;
      float: left;
      margin-right: 3rem;
      cursor: pointer;

      > div {
        transition: all 0.3s;
      }

      &.active,
      &:hover {
        > div {
          box-shadow: 0 0.3rem 1.5rem 0 rgba(200, 200, 200, 0.75);
        }

        .sub-title {
          &:after {
            opacity: 1;
            visibility: visible;
          }
        }
      }

      &:nth-child(2) {
        .sub-title {
          margin-top: 0.8rem;
        }
      }

      &:nth-child(3),
      &:nth-child(4) {
        .sub-title {
          margin-top: 2.1rem;
        }
      }
    }

    .hot-title {
      display: none;
    }

    .buys-title {
      display: none;
    }

    .sub-title {
      position: relative;
      margin-top: 1.5rem;
      letter-spacing: 0.1rem;
      font-weight: bold;

      &:after {
        content: '';
        position: absolute;
        top: 0;
        bottom: 0;
        right: 0;
        margin: auto;
        width: 10px;
        height: 10px;
        background-color: colors('bg-sub');
        border-radius: 50%;
        opacity: 0;
        visibility: hidden;
        transition: all 0.3s;
      }
    }

    .goods-show {
      margin-left: 0;
    }

    .winery1 {
      padding: 0;
    }
  }

  .editor {
    margin-bottom: 1.3rem;
  }

  .ad-time {
    width: 67.5rem;
    float: left;
    min-height: 81.3rem;
    margin-right: 1.3rem;
    .el-form-item {
      margin-bottom: 3rem;
      &:nth-child(1),
      &:nth-child(3) {
        .el-form-item__label {
          line-height: initial !important;
        }
      }
    }

    .el-radio {
      display: block !important;
      margin-bottom: 1.7rem;
      &:last-child {
        margin-bottom: 0;
      }
    }

    .tips {
      color: colors('a4');
    }

    .ad-uploader,
    .el-upload {
      width: 17.5rem;
      height: 10.6rem;
      background-color: #f7f7f7;
      display: inline-block;
      vertical-align: bottom;
      margin-right: 1.3rem;
    }
    .preview-img {
      width: 100%;
    }

    .el-upload {
      position: relative;
      display: flex;
      align-items: center;
      justify-content: center;
      overflow: hidden;
    }

    .icon-tupian {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 2.8rem;
      height: 2.8rem;
      background-color: colors('d3');
      border-radius: 50%;
      margin: 0 auto;

      &:before {
        color: #fff;
        font-size: 1.1rem;
      }
    }

    .opearting {
      position: absolute;
      bottom: 0;
      width: 100%;
      height: 1.9rem;
      background-color: rgba(0, 0, 0, 0.6);
      display: flex;
      align-items: center;
      .change {
        width: 2.5rem;
        height: 1.3rem;
        line-height: 1.3rem;
        background-color: colors('bg-sub');
        border-radius: 0.6rem;
        display: inline-block;
        color: #fff;
        margin: 0 1.3rem 0 1.1rem;
      }
      .icon-shanchu {
        font-size: 1.1rem;
        color: #fff;
      }
    }

    .input-large {
      width: 17.5rem;
      margin-top: 0.9rem;
    }
    .btn-all {
      display: flex;
      justify-content: center;
      margin-top: 6.1rem;
    }
  }
  .decoration-wrap {
    width: 100%;
  }

  .preview-applets {
    width: 35rem;
    min-height: 81.3rem;
    float: left;
  }
  .scroll-x {
    width: 103.8rem;
  }
}
</style>
